export enum PcsEnrolmentStepEnum {
    RegistrationDetails = 'Registration details',
    PersonalDetails = 'Personal details',
    EducationalDetails = 'Educational details',
    WorkDetails = 'Work details',
    Payment = 'Payment'
}